import React, { useState, useEffect } from "react";
import AceEditor from "react-ace";
import Select from "react-select";
import { Tooltip, OverlayTrigger, Button } from "react-bootstrap";
import { IoIosRefresh } from "react-icons/io";
import { BiSend, BiRun } from "react-icons/bi";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Service from "../Service/http";
import parse from "html-react-parser";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { FadeLoader } from "react-spinners";
import { ClipLoader } from "react-spinners";
import SplitPane, { Pane } from "react-split-pane";
import { BsFillArrowUpRightCircleFill } from "react-icons/bs";
import { BsFillArrowDownLeftCircleFill } from "react-icons/bs";
import rehypeRaw from "rehype-raw";
import { Link } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import {FiRefreshCcw} from 'react-icons/fi';
import UserProblemAllSubmission from "../Submission/userProblemAllSubmissions";

import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/mode-c_cpp";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-csharp";
import "ace-builds/src-noconflict/mode-ruby";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/theme-nord_dark";
import "ace-builds/src-noconflict/theme-chrome";
import "ace-builds/src-noconflict/theme-twilight";
import "ace-builds/src-noconflict/theme-tomorrow_night_blue";
import "ace-builds/src-noconflict/theme-xcode";
import ReactMarkdown from 'react-markdown';
import { Resizable } from 'react-resizable';
import { margin } from "@mui/system";

const ReactTableFixedColumns = withFixedColumns(ReactTable);

function Code() {
  const { pid } = useParams();
  const service = new Service();

  let [data, setData] = useState([]); /*Table data*/
  let [pageData, setPageData] = useState({}); /*Meta Data about pages*/
  let [color, Setcolor] = useState('');
  let [background, SetBackground] = useState("#81C784");
  let [textColor, SetTextcolor] = useState("");
  let [displayMode, SetDisplayMode] = useState("V");

  /*Tells when the api need to be called*/
  let [getApi, setGetApi] = useState(0);

  /*Value of the filter applied*/
  let [verdictFilterValue, setverdictFilterValue] = useState("All");
  let [languageFilterValue, setlanguageFilterValue] = useState("All");

  /*List for Filter Dropdown*/
  let [verdicts, setVerdict] = useState(['All', "ACCEPTED", "WRONG ANSWER", "TIME LIMIT EXCEEDED", "RUNTIME ERROR", "PENDING", "OTHER", "COMPILATION ERROR"]);
  let [languages, setLanguage] = useState(['All', "CPP", "C#", "JAVA", "JAVASCRIPT", "PYTHON"]);
  /*Pagination Data*/
  let [pageNo, setPageNo] = useState(1);
  let [perPage, setPerPage] = useState(5);
  let [valid, setValid] = useState(true);

  const languageMap = {
    JAVA: "java",
    "CPP": "c_cpp",
    PYTHON: "python",
    JAVASCRIPT: "javascript",
    "C#": "csharp",
  };

  const navigate = useNavigate();
  let [themeOptions, setThemeOptions] = useState([
    { value: "github", label: "github" },
    { value: "monokai", label: "monokai" },
    { value: "nord_dark", label: "nord_dark" },
    { value: "chrome", label: "chrome" },
    { value: "twilight", label: "twilight" },
    { value: "tomorrow_night_blue", label: "tomorrow_night_blue" },
    { value: "xcode", label: "xcode" },
  ]);
  const [ProblemData, setProblemData] = useState({});

  const [any_submission_polling, setAny_submission_polling] = useState(false);

  const updateAllSubmission = async () =>{
    try{
    let st = false;
    const json = await service.get("api/userProblemSubmissions/" + pid + '?verdict=' + verdictFilterValue + '&lang=' + languageFilterValue + '&page=' + pageNo + "&perPage=" + perPage);
    let result = []
    let ind = ((json['result']['page'] - 1) * (json['result']['limit']) + 1)
    for await (var ele of json['result']['docs']) {
      let temp = {};
      temp['no'] = ind;
      temp['verdict'] = ele['verdict_string'];
      temp['lang'] = ele['language'];
      temp['timestamp'] = new Date(ele['createdAt']).toLocaleString();
      temp['verdictURL'] = '/submission/' + ele['_id'];
      temp['polling'] = ele['is_server_polling'];
      temp['submission_id'] = ele['_id'];
      if (ele['is_server_polling']){
        setAny_submission_polling(true);
        st = true;
      }
      result.push(temp);
      ind++;
    }
    setData(result);
    if (result.length === 0) {
      setValid(false);
    }
    setPageData({ 'total': json['result']['total'], 'limit': json['result']['limit'], 'page': json['result']['page'], 'pages': json['result']['pages'] });
    if (any_submission_polling || st){
      await getDelay(30000);
      updateAllSubmission();
    }
    else if(st == false){
      setAny_submission_polling(false);
    }
  }
  catch (error){
    console.log(error);
  }
  }

  const reEvalSubmission = async (id,verdict) =>{
    if (verdict == "PENDING"){
      service.get("api/re-evaluate/submission/old/"+id);
    }
    else{
      service.get("api/re-evaluate/submission/new/"+id);
    }
    updateAllSubmission();
  }

  useEffect(() => {
    service
      .get("api/userProblemSubmissions/" + pid + '?verdict=' + verdictFilterValue + '&lang=' + languageFilterValue + '&page=' + pageNo + "&perPage=" + perPage)
      .then((json) => {
        let st = false;
        let result = []
        let ind = ((json['result']['page'] - 1) * (json['result']['limit']) + 1)
        for (var ele of json['result']['docs']) {
          let temp = {};
          temp['no'] = ind;
          temp['verdict'] = ele['verdict_string'];
          temp['lang'] = ele['language'];
          temp['timestamp'] = new Date(ele['createdAt']).toLocaleString();
          temp['verdictURL'] = '/submission/' + ele['_id'];
          temp['polling'] = ele['is_server_polling'];
          temp['submission_id'] = ele['_id'];
          if (ele['is_server_polling']){
            setAny_submission_polling(true);
            st = true;
          }
          result.push(temp);
          ind++;
        }
        setData(result);
        if (result.length === 0) {
          setValid(false);
        }
        setPageData({ 'total': json['result']['total'], 'limit': json['result']['limit'], 'page': json['result']['page'], 'pages': json['result']['pages'] });
        if (any_submission_polling || st){
          updateAllSubmission();
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }, [getApi]);

  const handleChange = (e, v) => {
    setPageNo(v);
    setGetApi(getApi + 1);
  };

  let defaultCode = {
    "CPP": "#include <bits/stdc++.h>\nusing namespace std;\n\nint main(){\n\n}",
    "PYTHON": "def main():\n\t\nmain()",
    "JAVA": "public class Main\n{\n\tpublic static void main(String[] args) {\n\t\tSystem.out.println();\n\t}\n}",
    "JAVASCRIPT": "console.log();",
    "C#": "namespace Main\n{\nclass Main {\n\tstatic void Main(string[] args)\n\t{\n\t\tSystem.Console.WriteLine();\n\t}\n}"
  }

  let [currentLanguage, setCurrentLanguage] = useState({
    value: "CPP",
    userCode: "",
    label: "C++",
    instructorCode: "BACDFDE",
  });

  useEffect(() => {
    setCurrentCode(localStorage.getItem(currentLanguage.value + pid) || defaultCode[currentLanguage.value]);
    service.get("api/problem/" + pid).then((res) => {
      setProblemData(res);
    })
    let data = localStorage.getItem(currentLanguage.value + pid);
  }, []);

  let [loadingOutput, setloadingOutput] = useState(false);
  let [loadingSubmit, setloadingSubmit] = useState(false);
  let [currentInput, setCurrentInput] = useState("");

  let [currentTheme, setCurrentTheme] = useState({
    value: "nord_dark",
    label: "nord_dark",
  });

  let [currentCode, setCurrentCode] = useState("");

  const onChangeCode = (codee) => {
    localStorage.setItem(
      currentLanguage.value + pid,
      codee
    );
    setCurrentCode(codee);
  };

  const [verdictExists, setVerdictExists] = useState(false);
  const [runVerdict, setRunVerdict] = useState("");
  const [currentOutput, setCurrentOutput] = useState("");
  const onRun = () => {
    setloadingOutput(true);
    setVerdictExists(false);
    setCurrentOutput("");
    if (currentCode == "" || currentCode == null) {
      alert("Code cannot be empty");
      setloadingOutput(false);
      return;
    }
    service.post("api/runSubmission",
      { problem_id: ProblemData._id, language: currentLanguage.value, code: currentCode, input: currentInput }).
      then((res) => {
        getRunStatus(res.data);
      })
      .catch((err) => {
        alert("Failed to run code please try later");
        setloadingOutput(false);
      })
    document.getElementById("output").focus();
  }

  const getDelay = (time) => {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  const getRunStatus = async (id) => {
    let attempts = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    let st = true;
    try {
      let data;
      for await (const attempt of attempts) {
        if (attempt == 0) {
          await getDelay(5000);
        }
        data = await service.get("api/runCodeStatus/" + id);
        if (data.msg == "true") {
          st = false;
          break;
        }
        await getDelay(10000);
      }
      if (st == true) {
        alert("Failed to run please try later");
      }
      else {
        if (data.data.verdict_code != 1) {
          setVerdictExists(true);
          setRunVerdict(data.data.verdict_string);
        }
        setCurrentOutput(data.data.output);
      }
    }
    catch (err) {
      alert("Failed to run please try later");
    }
    setloadingOutput(false);
  }

  const onSubmit = () => {
    setloadingSubmit(true);
    service.post("api/create/submission",
      { problem_id: ProblemData._id, language: currentLanguage.value, code: currentCode })
      .then((res) => {
        if (res.msg == "fail") {
          alert("Failed to submit please try after some time");
          setloadingSubmit(false);
        }
        else {
          handleSubmit(res.data);
          handleModal();
        }
      })
      .catch((res) => {
        alert("Failed to submit please try after some time");
        setloadingSubmit(false);
      });
  }

  const [server_polling_status, SetServer_polling_status] = useState({});
  const [submission_verdicts, SetSubmission_verdicts] = useState({});

  const [cur_submission_verdict, SetCur_submission_verdict] = useState("");

  const handleSubmit = async (id) => {
    SetCur_submission_verdict("PENDING");
    let attempts = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    let data = [];
    for await (let attempt of attempts) {
      try {
        const json = await service.get("api/submission/" + id);
        setSubmissionData(json);
        data = json;
        // let obj_poll_st = {};
        // obj_poll_st[json[0]] = json[11];
        // let obj_verdict = {};
        // obj_verdict[json[0]] = json[5];
        // SetServer_polling_status({...server_polling_status, obj_poll_st });
        // SetSubmission_verdicts({...submission_verdicts, obj_verdict });
        if (json[11] == false) {
          break;
        }
        await getDelay(10000);
      }
      catch (err) {
        console.log(err);
      }
    }
    SetCur_submission_verdict(data[5]);
    setloadingSubmit(false);
  }

  const onRefreshEditor = () => {
    let result = window.confirm("Are You Sure You want to Reset your Code?");
    if (result) {
      localStorage.removeItem(
        currentLanguage.value + pid
      );
      setCurrentCode(defaultCode[currentLanguage.value]);
    }
  };

  const renderTooltipInitial = (props) => (
    <Tooltip id="button-tooltip-initial-code" {...props}>
      Reload Initial Code
    </Tooltip>
  );

  const onChangeLanguage = (event) => {
    setCurrentLanguage(event);
    setCurrentCode(localStorage.getItem(event.value + pid) || defaultCode[event.value]);
  };

  let [options, setOptions] = useState([
    { value: "CPP", userCode: "", label: "C++" },
    { value: "C#", userCode: "", label: "C#" },
    { value: "JAVA", userCode: "", label: "Java" },
    { value: "JAVASCRIPT", userCode: "", label: "JavaScript" },
    { value: "PYTHON", userCode: "", label: "Python" }
  ]);

  const onChangeTheme = (event) => {
    setCurrentTheme(event);
  };
  let [splitsize, setsplitsize] = useState((window.innerWidth / 10) * 6);

  let [submissionData, setSubmissionData] = useState([]);
  //Modal display
  let [showing, setShowing] = useState(false);
  //Copy Button
  let [isCopied, setCopy] = useState(false);

  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    }
    else {
      return document.execCommand('copy', true, text);
    }
  }

  const handleCopyClick = () => {
    copyTextToClipboard(submissionData[8]).then(() => {
      setCopy(true);
      setTimeout(() => {
        setCopy(false);
      }, 1500);
    })
      .catch((err) => {
        console.log(err);
      });
  }

  const onReevaluate = () =>{
    SetCur_submission_verdict("PENDING");
    if (submissionData[5] == "PENDING"){
      service.get("api/re-evaluate/submission/old/"+submissionData[0]);
    }
    else{
      service.get("api/re-evaluate/submission/new/"+submissionData[0]);
    }
    handleSubmit(submissionData[0]);
  }

  const originalWarn = console.warn;
  console.warn = function (...args) {
    const arg = args && args[0];
    if (arg && arg.includes('Attempting to load version \'51\' of Google Charts')) return;
    originalWarn(...args);
  };

  const handleModal = () => {
    setShowing(!showing);
  }

  const moveToSubmission = ()=>{
    navigate("/problem/submissions/"+pid);
  }

  

  if (displayMode == "V") {
    return (
      <>


        <div>
          <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active"
                data-bs-toggle="tab"
                href="#home"
                aria-selected="true"
                role="tab"
                style={{fontWeight: "bolder"}}
              >
                Problem Statement
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                onClick={moveToSubmission}
                aria-selected="false"
                role="tab"
                tabindex="-1"
                style={{fontWeight: "bolder", cursor:"pointer"}}
              >
                Submissions
              </a>
            </li>
          </ul>
          <div id="myTabContent" className="tab-content">
            <div className="tab-pane fade active show" id="home" role="tabpanel">
              <>
                <SplitPane
                  primary="first"
                  style={
                    ({ height: "105vh" })
                  }
                  split="vertical"
                  minSize={window.innerWidth / 3}
                  defaultSize={(window.innerWidth / 10) * 6}
                  maxSize={(window.innerWidth / 10) * 7}
                  onChange={(size) => {
                    setsplitsize(size);
                  }}
                  flex>
                  <Pane className="bg-light"
                    style={{
                      height: "100vh",
                      overflowY: "scroll",
                      overflowX: "hidden",
                    }}>
                    <div style={{ width: splitsize }} className="m-2 border p-2 bg-white">
                      <h4 style={{ fontWeight: 550 }}>{ProblemData.title}</h4>
                      {ProblemData ? <ReactMarkdown children={ProblemData.problem_description} rehypePlugins={[rehypeRaw]}></ReactMarkdown> : null}
                    </div>
                  </Pane>

                  <Pane
                    style={{
                      height: "100vh",
                      overflowY: "scroll",
                      overflowX: "scroll",
                    }}>
                    <div className="m-2 ">
                      <div className="border">
                        <div className="row ">
                          <div className=" col-sm-1  text-success">
                            <OverlayTrigger
                              placement="left"
                              delay={{ show: 0, hide: 400 }}
                              overlay={renderTooltipInitial}
                            >
                              <Button variant="outline-light">
                                <IoIosRefresh
                                  className="text-success"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    onRefreshEditor();
                                  }}
                                  size={25}
                                />
                              </Button>
                            </OverlayTrigger>
                          </div>

                          <div className="col-sm-3 my-1">
                            <Select
                              placeholder={"language"}
                              value={options.filter(function (option) {
                                return option.value === currentLanguage.value;
                              })}
                              singleValue={true}
                              onChange={onChangeLanguage}
                              options={options}
                            />
                          </div>

                          <div className="col-sm-3 my-1">
                            <Select
                              placeholder={"Theme"}
                              singleValue={true}
                              value={themeOptions.filter(function (option) {
                                return option.value === currentTheme.value;
                              })}
                              onChange={onChangeTheme}
                              options={themeOptions}
                            />
                          </div>
                          <div className="col-sm-3 my-1">
                            <Button onClick={() => {
                              SetDisplayMode("H");
                            }}>
                              <BsFillArrowDownLeftCircleFill />
                            </Button>
                          </div>
                        </div>


                        <AceEditor
                          fontSize="11pt"
                          height="70vh"
                          width="auto"
                          mode={languageMap[currentLanguage.value]}
                          theme={currentTheme.value}
                          showPrintMargin={false}
                          onChange={onChangeCode}
                          name="UNIQUE_ID_OF_DIV"
                          editorProps={{ $blockScrolling: true }}
                          setOptions={{
                            enableBasicAutocompletion: true,
                            enableLiveAutocompletion: true,
                            enableSnippets: true,
                          }}
                          value={currentCode ||
                            localStorage.getItem(
                              currentLanguage.value +
                              pid
                            )
                          }
                        />

                        <div className="row m-1">
                          <div className="col-auto ">
                            <button
                              type="button"
                              onClick={onRun}
                              className="btn btn-outline-primary mt-1 p-2 px-2 "
                              disabled={loadingOutput || loadingSubmit}
                            >
                              Run Code <BiRun className="mb-1"></BiRun>
                            </button>
                          </div>
                          <div className="col-auto">
                            <button
                              type="button"
                              onClick={onSubmit}
                              className=" btn btn-outline-primary mt-1 p-2 px-2  "
                              disabled={loadingSubmit || loadingOutput}
                            >
                              SUBMIT <BiSend className="mb-1"></BiSend>{" "}
                            </button>
                          </div>
                        </div>
                      </div>

                      <br />

                      <div>
                        <div className="col-sm-12 mb-5">
                          <div className="m-1">Input</div>
                          <textarea
                            value={currentInput || ""}
                            onChange={(event) => {
                              setCurrentInput(event.target.value);
                            }}
                            placeholder="Input"
                            className="form-control "
                            rows="5"
                          ></textarea>
                        </div>

                        <div className="col-sm-12 mb-5">
                          <div className="m-1">Output{verdictExists ? <div style={{ display: "inline" }}> - <p style={{ color: "crimson", display: "inline" }}>{runVerdict}</p></div> : null}</div>
                          {loadingOutput ? <div className="text-center"><FadeLoader color={"blue"} /></div> :
                            <textarea
                              id="output"
                              value={currentOutput || ""}
                              onChange={(event) => {
                                setCurrentInput(event.target.value);
                              }}
                              placeholder="Output"
                              className="form-control "
                              rows="5"
                            ></textarea>}
                        </div>
                      </div>
                    </div>
                  </Pane>
                </SplitPane>

              </>

            </div>
            <div className="tab-pane fade" id="profile" role="tabpanel">
              <UserProblemAllSubmission problemId = {pid} />
            </div>
          </div>
        </div>
        {submissionData !== [] ? <div>
          <Modal size="lg" aria-labelledby="example-modal-sizes-title-lg" show={showing} onHide={handleModal}>
            <Modal.Header closeButton>
              <Modal.Title><a href={"/submission/" + submissionData[0]} target="_blank">{submissionData[0]}</a> | <Link to={"/coding/profile/" + submissionData[1]} >{submissionData[2]}</Link>'s submission for the problem <Link to={"/code/" + submissionData[3]}>{submissionData[4]}</Link></Modal.Title>
            </Modal.Header>
            <Modal.Body><Table striped bordered hover size='sm' className="p-0" style={{ alignContent: 'center' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>Result</th>
                  <th style={{ textAlign: 'center' }}>Language</th>
                  <th style={{ textAlign: 'center' }}>Submited At</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ color: cur_submission_verdict === 'ACCEPTED' ? "#76B947" : (cur_submission_verdict === 'PENDING') || (cur_submission_verdict == 'SERVER ERROR') ? "Gray" : "#E43D40" }}>
                    <div style={{
                      display: "flex", gap : ".4rem" ,flexDirection: "row", justifyContent: "center", alignItems: "center",
                    }}>
                      <div style={{
                        marginTop: ".3rem"
                      }}>
                        {( submissionData[11] === true) ?
                          <ClipLoader style={{
                            marginTop : "1rem !important"
                          }} color="blue" size="16" />
                          : (submissionData[11]) === false && (cur_submission_verdict =="PENDING")
                          ? <FiRefreshCcw  title="Refresh" style={{cursor: "pointer", display:"inline", marginBottom: ".5rem" }} onClick={onReevaluate}
                         color="#FFC000" size="18" /> : (submissionData[11]) === false && (cur_submission_verdict =="SERVER ERROR")? <FiRefreshCcw  title="Re-evaluate" style={{cursor: "pointer", display:"inline", marginBottom: ".5rem" }} onClick={onReevaluate}
                         color="#FFC000" size="18" />: null } </div> <div>{cur_submission_verdict} </div>
                    </div>
                  </td>
                  <td style={{ textAlign: 'center' }}>{submissionData[6]}</td>
                  <td style={{ textAlign: 'center' }}>{new Date(submissionData[7]).toLocaleString()}
                  </td>
                </tr>

              </tbody>
            </Table>

            {(submissionData[11] == false) && (cur_submission_verdict!="PENDING" && cur_submission_verdict!="SERVER ERROR")?<div style={{ backgroundColor: "#FEF1CD", padding: "0.5em 0.5em 0.5em 0.5em" }}>{submissionData[9]} / {submissionData[10]} passed</div>:null}<p></p>
              <Button variant="secondary" onClick={handleCopyClick} style={{ float: "right" }}><span>{isCopied ? 'Copied!' : 'Copy Code'}</span></Button>

              <AceEditor
                mode={submissionData[6] === 'cpp' ? 'c_cpp' : (submissionData[6] === 'c#' ? 'csharp' : submissionData[6])}
                theme="solarized_dark"
                value={submissionData[8]}
                readOnly={true}
                width="auto"
              /></Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleModal}>
                Close
              </Button>

            </Modal.Footer>
          </Modal></div> : null}
      </>
    );
  }
  else {
    return (
      <>
        <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active"
                data-bs-toggle="tab"
                href="#home"
                aria-selected="true"
                role="tab"
                style={{fontWeight: "bolder"}}
              >
                Problem Statement
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                onClick={moveToSubmission}
                aria-selected="false"
                role="tab"
                tabindex="-1"
                style={{fontWeight: "bolder", cursor:"pointer"}}
              >
                Submissions
              </a>
            </li>
          </ul>
        <div id="myTabContent" className="tab-content">
          <div className="tab-pane fade active show" id="home" role="tabpanel">
            <>
              <div className="m-2 border p-2 bg-white">
                <h4 style={{ fontWeight: 550 }}>{ProblemData.title}</h4>
                {ProblemData ? <ReactMarkdown children={ProblemData.problem_description} rehypePlugins={[rehypeRaw]}></ReactMarkdown> : null}
              </div>
              <div className="m-2 ">
                <div className="border">
                  <div className="row ">
                    <div className=" col-sm-1  text-success">
                      <OverlayTrigger
                        placement="left"
                        delay={{ show: 0, hide: 400 }}
                        overlay={renderTooltipInitial}
                      >
                        <Button variant="outline-light">
                          <IoIosRefresh
                            className="text-success"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              onRefreshEditor();
                            }}
                            size={25}
                          />
                        </Button>
                      </OverlayTrigger>
                    </div>

                    <div className="col-sm-3 my-1">
                      <Select
                        placeholder={"language"}
                        value={options.filter(function (option) {
                          return option.value === currentLanguage.value;
                        })}
                        singleValue={true}
                        onChange={onChangeLanguage}
                        options={options}
                      />
                    </div>

                    <div className="col-sm-3 my-1">
                      <Select
                        placeholder={"Theme"}
                        singleValue={true}
                        value={themeOptions.filter(function (option) {
                          return option.value === currentTheme.value;
                        })}
                        onChange={onChangeTheme}
                        options={themeOptions}
                      />
                    </div>
                    <div className="col-sm-3 my-1">
                      <Button onClick={() => {
                        SetDisplayMode("V");
                      }}>
                        <BsFillArrowUpRightCircleFill />
                      </Button>
                    </div>
                  </div>
                  <AceEditor
                    fontSize="11pt"
                    height="70vh"
                    width="auto"
                    mode={languageMap[currentLanguage.value]}
                    theme={currentTheme.value}
                    showPrintMargin={false}
                    onChange={onChangeCode}
                    name="UNIQUE_ID_OF_DIV"
                    editorProps={{ $blockScrolling: true }}
                    setOptions={{
                      enableBasicAutocompletion: true,
                      enableLiveAutocompletion: true,
                      enableSnippets: true,
                    }}
                    value={currentCode ||
                      localStorage.getItem(
                        currentLanguage.value +
                        pid
                      )
                    }
                  />

                  <div className="row m-1">
                    <div className="col-auto ">
                      <button
                        type="button"
                        onClick={onRun}
                        className="btn btn-outline-primary mt-1 p-2 px-2 "
                        disabled={loadingOutput || loadingSubmit}
                      >
                        Run Code <BiRun className="mb-1"></BiRun>
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="button"
                        onClick={onSubmit}
                        className=" btn btn-outline-primary mt-1 p-2 px-2  "
                        disabled={loadingSubmit || loadingOutput}
                      >
                        SUBMIT <BiSend className="mb-1"></BiSend>{" "}
                      </button>
                    </div>
                  </div>
                </div>

                <br />

                <div>
                  <div className="col-sm-12 mb-5">
                    <div className="m-1">Input</div>
                    <textarea
                      value={currentInput || ""}
                      onChange={(event) => {
                        setCurrentInput(event.target.value);
                      }}
                      placeholder="Input"
                      className="form-control "
                      rows="5"
                    ></textarea>
                  </div>

                  <div className="col-sm-12 mb-5">
                    <div className="m-1">Output{verdictExists ? <div style={{ display: "inline" }}> - <p style={{ color: "crimson", display: "inline" }}>{runVerdict}</p></div> : null}</div>
                    {loadingOutput ? <div className="text-center"><FadeLoader color={"green"} /></div> :
                      <textarea
                        id="output"
                        value={currentOutput || ""}
                        onChange={(event) => {
                          setCurrentInput(event.target.value);
                        }}
                        placeholder="Output"
                        className="form-control "
                        rows="5"
                      ></textarea>}
                  </div>
                </div>
              </div>
            </>
          </div>
          <div className="tab-pane fade" id="profile" role="tabpanel">
            <UserProblemAllSubmission problemId = {pid} />
          </div>
        </div>
        {submissionData !== [] ? <div>
          <Modal size="lg" aria-labelledby="example-modal-sizes-title-lg" show={showing} onHide={handleModal}>
            <Modal.Header closeButton>
              <Modal.Title><a href={"/submission/" + submissionData[0]} target="_blank">{submissionData[0]}</a> | <Link to={"/coding/profile/" + submissionData[1]} >{submissionData[2]}</Link>'s submission for the problem <Link to={"/code/" + submissionData[3]}>{submissionData[4]}</Link></Modal.Title>
            </Modal.Header>
            <Modal.Body><Table striped bordered hover size='sm' className="p-0" style={{ alignContent: 'center' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>Result</th>
                  <th style={{ textAlign: 'center' }}>Language</th>
                  <th style={{ textAlign: 'center' }}>Submited At</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                <td style={{ color: cur_submission_verdict === 'ACCEPTED' ? "#76B947" : cur_submission_verdict === 'PENDING' || cur_submission_verdict == 'SERVER ERROR' ? "Gray" : "#E43D40" }}>
                <div style={{
                      display: "flex", gap : ".4rem" ,flexDirection: "row", justifyContent: "center", alignItems: "center",
                    }}>
                      <div style={{
                        marginTop: ".3rem"
                      }}>
                        {( submissionData[11] === true) ?
                          <ClipLoader style={{
                            marginTop : "1rem !important"
                          }} color="blue" size="16" />
                          : (submissionData[11]) === false && (cur_submission_verdict =="PENDING")
                          ? <FiRefreshCcw  title="Refresh" style={{cursor: "pointer", display:"inline", marginBottom: ".5rem" }} onClick={onReevaluate}
                         color="#FFC000" size="18" /> : (submissionData[11]) === false && (cur_submission_verdict =="SERVER ERROR")? <FiRefreshCcw  title="Re-evaluate" style={{cursor: "pointer", display:"inline", marginBottom: ".5rem" }} onClick={onReevaluate}
                         color="#FFC000" size="18" />: null } </div> <div>{cur_submission_verdict} </div>
                    </div>
                  </td>
                  <td style={{ textAlign: 'center' }}>{submissionData[6]}</td>
                  <td style={{ textAlign: 'center' }}>{new Date(submissionData[7]).toLocaleString()}</td>
                </tr>

              </tbody>
            </Table>

              {(submissionData[11] == false) && (cur_submission_verdict!="PENDING" && cur_submission_verdict!="SERVER ERROR")?<div style={{ backgroundColor: "#FEF1CD", padding: "0.5em 0.5em 0.5em 0.5em" }}>{submissionData[9]} / {submissionData[10]} passed</div>:null}<p></p>
              <Button variant="secondary" onClick={handleCopyClick} style={{ float: "right" }}><span>{isCopied ? 'Copied!' : 'Copy Code'}</span></Button>

              <AceEditor
                mode={submissionData[6] === 'cpp' ? 'c_cpp' : (submissionData[6] === 'c#' ? 'csharp' : submissionData[6])}
                theme="solarized_dark"
                value={submissionData[8]}
                readOnly={true}
                width="auto"
              /></Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleModal}>
                Close
              </Button>

            </Modal.Footer>
          </Modal></div> : null}
      </>);
  }
}
export default Code;